/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minValue: NonNullable<unknown> }} Keen_Warm_Bear_SpanInputs */

const en_keen_warm_bear_span = /** @type {(inputs: Keen_Warm_Bear_SpanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From ${i?.minValue}%`)
};

const de_keen_warm_bear_span = /** @type {(inputs: Keen_Warm_Bear_SpanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ab ${i?.minValue}%`)
};

/**
* | output |
* | --- |
* | "From {minValue}%" |
*
* @param {Keen_Warm_Bear_SpanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_warm_bear_span = /** @type {((inputs: Keen_Warm_Bear_SpanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Warm_Bear_SpanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_warm_bear_span(inputs)
	return de_keen_warm_bear_span(inputs)
});